import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { Hex } from 'viem'

import { spark2ApiUrl } from '@/config/consts'
import { ConnectReferralCodeArgs } from '@/features/points/dialogs/points-onboarding-dialog/logic/useConnectReferralCode'

interface SubmitReferralCodeSignatureArgs extends ConnectReferralCodeArgs {
  signature: Hex
}

export function useSubmitReferralCodeSignature({
  onError,
}: {
  onError: () => void
}): UseMutationResult<void, Error, SubmitReferralCodeSignatureArgs> {
  return useMutation({
    mutationFn: async ({ referralCode, account, signature }) => {
      const res = await fetch(`${spark2ApiUrl}/referrals/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          invite_referral_code: referralCode,
          invitee: account,
          eip712_signature: signature,
        }),
      })
      if (!res.ok) {
        throw new Error('Failed to submit invite code')
      }
    },
    onError,
  })
}
